export type InvestorTypeValue = 'CONSERVATIVE' | 'BALANCED' | 'DYNAMIC' | 'AGGRESSIVE' | 'CAREFUL'

export const InvestorType = {
  conservative: 'CONSERVATIVE' as InvestorTypeValue,
  balanced: 'BALANCED' as InvestorTypeValue,
  dynamic: 'DYNAMIC' as InvestorTypeValue,
  aggressive: 'AGGRESSIVE' as InvestorTypeValue,
  careful: 'CAREFUL' as InvestorTypeValue
}

export const Segment = {
  MA: 'MA',
  MM: 'MM'
}

export type SegmentType = keyof typeof Segment

export type InvestorTypeKeys = keyof typeof InvestorType

interface IRegInvestResponse {
  cumulativeAmount: number
  estimatedAmount: number
  annualReturn: number
  productName: string
  productId: string
}

export interface IRegInvestAmountRequest {
  investorType: InvestorTypeValue
  targetAmount: number
  yearCount: number
  initDeposit: number
  segment?: SegmentType
}

export interface IRegInvestAmountResponse extends IRegInvestResponse {
  targetAmount: number
}

export interface IRegInvestSavingsRequest {
  investorType: InvestorTypeValue
  monthlySavings: number
  yearCount: number
  initDeposit: number
  segment?: SegmentType
}

// tslint:disable-next-line: no-empty-interface
export interface IRegInvestSavingsResponse extends IRegInvestResponse {}
